import resolveConfig from 'tailwindcss/resolveConfig';
import { getAppConfig } from 'config/utils';

const { theme } = getAppConfig(process.env.REACT_APP_NAME);

export default resolveConfig(theme).theme;
